import { ScrollArea } from '@art-of-hospitality-solutions-llc/ui-kit/components/scroll-area';

export default function PhonePreviewContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative mx-auto w-[375px]">
      {/* Phone Outer Frame with Shadow */}
      <div className="relative rounded-[3.4rem] bg-zinc-900 p-3 pb-4 shadow-2xl">
        {/* Phone Screen Bezel */}
        <div className="relative h-[760px] overflow-hidden rounded-[2.6rem] bg-zinc-950">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 z-10 h-6 w-32 -translate-x-1/2 rounded-b-2xl bg-zinc-900" />
          {/* Screen Content */}
          <ScrollArea className="h-full">
            <div className="bg-zinc-950">{children}</div>
          </ScrollArea>
        </div>
      </div>
    </div>
  );
}
